import { useGetEnrollmentDetailSuspense } from '@ijoin/hooks';
import { Card, CardContent, CardHeader } from '@mui/material';

import { FC } from 'react';

import { SubmissionDiffSections } from './SubmissionDiffSections';

export const EnrollmentChangesSection: FC<{
  planEnrollmentId: string;
  planId: string;
}> = props => {
  const detail = useGetEnrollmentDetailSuspense(
    props.planId,
    props.planEnrollmentId
  );

  return (
    <Card sx={{ p: 1 }}>
      <CardHeader title='Changes Since Sync' />
      <CardContent>
        <SubmissionDiffSections
          details={{
            diff: detail.data.diff ?? [],
            initialSnapshot: detail.data.initialSnapshot ?? null,
            submittedSnapshot: detail.data.currentSnapshot ?? null
          }}
          submittedHeaderName='Current'
        />
      </CardContent>
    </Card>
  );
};

EnrollmentChangesSection.displayName = 'EnrollmentChangesSection';
